var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"edit-banner",attrs:{"height":"45","icon":"mdi-alert-circle-outline","text":"","type":"info"}},[_vm._v(" "+_vm._s(_vm.editDescription)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }